<script>
import Layout from "@/components/pages/layouts/vertical";
import AreaSummary from "@/components/widgets/area-summary";
import ItemSummary from "@/components/widgets/item-summary";
import ServicesBlock from "@/components/widgets/services-block";
import VirtualTourView from "@/components/widgets/virtual-tour-view";
//import { GChart } from 'vue-google-charts/legacy';
import { mapState } from 'vuex';

/**
 * Dashboard Component
 */
export default {
  components: { Layout, AreaSummary, ItemSummary, ServicesBlock, VirtualTourView },
  computed: {
    ...mapState("property", ["properties"]),
    selectedProperty() {
      // Hardcoded but this could be a cookie for default property
      return this.properties[0];
    },
    virtualTourLink() {
      if (this.selectedProperty)
        return this.selectedProperty.activation_info.virtual_tour_link;
      else
        return null;
    },
    photos() {
      return this.selectedProperty.photos;
    },
    mainPhoto() {
      return this.photos[0];
    },
    areas() {
      return this.selectedProperty.areas;
    },
    // chartByRoom() {
    //   // Mock data
    //   return {
    //     data: [
    //       ['Room', 'Value'],
    //       ['Kitchen', 12500],
    //       ['Living Room', 9400],
    //       ['Dining Room', 5100],
    //       ['Primary Bedroom', 500],
    //       ['Bedroom 1', 300],
    //       ['Bedroom 2', 250],
    //       ['Bedroom 3', 100],
    //       ['Patio/Pool', 100],
    //     ],
    //     options: {
    //       title: 'Value of Items by Room',
    //       chartArea: { left: '5%', top: '15%', width: '90%', height: '80%' },
    //       legend: {
    //         alignment: 'center',
    //       },
    //       titleTextStyle: {
    //         fontSize: 14
    //       },
    //       width: 250,
    //       height: 250
    //     }
    //   };
    // },
    // chartByCategory() {
    //   // Mock data
    //   return {
    //     data: [
    //       ['Category', 'Value'],
    //       ['Computer Hardware', 12820.30],
    //       ['Musical Instruments', 10797.76],
    //       ['Electronics', 4009.97],
    //       ['Furniture', 3702.68],
    //       ['Appliances', 1809.46],
    //       ['Uncategorized', 1059],
    //       ['Miscellaneous', 889.98],
    //       ['Other', 1186.06],
    //     ],
    //     options: {
    //       title: 'Value of Items by Category',
    //       chartArea: { left: '5%', top: '15%', width: '90%', height: '80%' },
    //       legend: {
    //         alignment: 'center'
    //       },
    //       titleTextStyle: {
    //         fontSize: 14
    //       },
    //       width: 250,
    //       height: 250
    //     }
    //   };
    // }
  },
  data() {
    return {
      showModal: false,
      isLoading: false,
      fullPage: true,
      canCancel: false,
      useSlot: false,
      loader: "spinner",
      color: "#007bff",
      bgColor: "#ffffff",
      height: 128,
      width: 128,
      timeout: 3000, //ms
      fetchingStats: true,
    };
  }
};
</script>

<style>
  .residence-label {
    position: absolute;
    z-index: 99;
    background-color: #fff;
    border: 1px solid #e7e7e7;
    font-size: 1.2rem;
    color: #000;
    padding: 0.25rem 0.5rem;
  }

  .main-photo {
    position: relative;
    max-height: 400px;
    overflow-y: hidden;
  }

  .main-photo > img {
    width: 100%;
  }

  .btn-link.vr-view {
    position: absolute;
    z-index: 99;
    bottom: 0.25rem;
    left:  1.5rem;
  }

  .btn-link.vr-view > img {
    width: 50px;
  } 
</style>

<template>
  <Layout >
    <b-modal v-model="showModal" hide-footer centered header-class="border-0">
      <div class="text-center mb-4">
        <div class="avatar-md mx-auto mb-4">
          <div class="avatar-title bg-light rounded-circle text-primary h1">
            <i class="mdi mdi-email-open"></i>
          </div>
        </div>

        <div class="row justify-content-center">
          <div class="col-xl-10">
            <h4 class="text-primary">Subscribe !</h4>
            <p class="text-muted font-size-14 mb-4">
              Subscribe our newletter and get notification to stay update.
            </p>

            <div class="input-group bg-light rounded">
              <input
              type="email"
              class="form-control bg-transparent border-0"
              placeholder="Enter Email address"
              aria-label="Recipient's username"
              aria-describedby="button-addon2"
              />

              <button class="btn btn-primary" type="button" id="button-addon2">
                <i class="bx bxs-paper-plane"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </b-modal>
    <h2 v-if="$can('read', 'Area')" class="residence-label">{{ selectedProperty.category }}</h2>
    <b-row v-if="$can('read', 'Area')"> 
      <b-col lg="6">
        <div v-if="this.mainPhoto" class="main-photo">
          <b-link class="vr-view btn-link" v-b-modal.modal-VirtualTourView>
            <img src="@/assets/images/360-icon.png">
          </b-link>
          <img :src="mainPhoto.image_url">
        </div>
        <AreaSummary :propertyName="this.selectedProperty.category" :areas="this.areas" />
        <ItemSummary :propertyId="this.selectedProperty.id" :propertyName="this.selectedProperty.category" :areas="this.areas" />
        <VirtualTourView v-if="this.virtualTourLink" :viewSource="this.virtualTourLink" />
      </b-col>
      <b-col lg="6">
        <!-- <b-row>
          <b-col>
            <GChart
              type="PieChart"
              :data="chartByRoom.data"
              :options="chartByRoom.options"
            />
          </b-col>
          <b-col>
            <GChart
              type="PieChart"
              :data="chartByCategory.data"
              :options="chartByCategory.options"
            />
          </b-col>
        </b-row> -->
        <ServicesBlock />
      </b-col>
    </b-row>
  </Layout>
</template>
